export default {
  headerContent: {
    title: 'Yabancı Sağlık Sigortası',
    slogan: "Yabancı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'YABANCI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Yabancı Sağlık Sigortası',
    description: {
      title: 'Groupama Yabancı Sağlık Sigortası Nedir?',
      content: [
        'Yabancı sağlık sigortası, Türkiye’de ikamet edecek kişilerin yaptırması zorunlu olan sigorta ürünüdür. Groupama yabancı sağlık sigortası ile birey Türkiye’de karşılaşabileceği hastalık risklerini güvence altına almış olur.'
      ]
    },
    subContent: {
      title: 'Groupama Yabancı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Groupama Sigorta sigortalılarına Yatarak ve Ayakta tedavi teminatı sunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Ayakta tedavi teminatı kapsar;',
          subList: [
            'Doktor Muayene',
            'Fizik Tedavi ve Rehabilitasyon',
            'İlaç',
            'Küçük Müdahale',
            'Modern Teşhis',
            'Röntgen',
            'Tahlil'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Yatarak tedavi teminatı;</u></em></strong> anlaşmalı hastanelerde limitsiz olarak sunmaktadır. Anlaşmalı olmayan hastanelerde 20.000 TL limit ve %20 katılım payını sigortalı tarafından karşılanmak üzere sunulmaktadır.',
          subList: null
        },
        {
          paragraph: 'Yatarak Tedavi teminatı Kapsamı;',
          subList: [
            'Ameliyat',
            'Hastane Oda - Refakatçi',
            'Hastane Tedavi',
            'Özellikli Tedavi (Radyoterapi, Kemoterapi, Diyaliz)',
            'Yoğun Bakım',
            'Anjiograf'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Yabancı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Yabancı Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
